module.exports = "/_next/static/images/teaser2-slice-2-db83c3b50384aa61bf236626758bda10.jpg";